import { render, staticRenderFns } from "./NavbarBreadcrumb.vue?vue&type=template&id=27860ae3"
import script from "./NavbarBreadcrumb.vue?vue&type=script&lang=js"
export * from "./NavbarBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27860ae3')) {
      api.createRecord('27860ae3', component.options)
    } else {
      api.reload('27860ae3', component.options)
    }
    module.hot.accept("./NavbarBreadcrumb.vue?vue&type=template&id=27860ae3", function () {
      api.rerender('27860ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavbarBreadcrumb.vue"
export default component.exports